// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuccessPage_container__05SLA {
  display: flex;
  flex-direction: column;
}

.SuccessPage_successHeadingContainer__GPTw8 {
  display: flex;
  flex-direction: column;
  padding-top: 64px;
  gap: 16px;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.SuccessPage_appImage__GiqVt{
  width: 256px;
  height: 256px;
  object-fit: contain;
  align-self: center;
}

.SuccessPage_successIcon__\\+4EfR {
  width: 48px;
  height: 48px;
}

.SuccessPage_successPaymentText__B0zqo {
  margin: 0;
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
  letter-spacing: 0%;
  text-align: center;
  color: #333333;
}

.SuccessPage_detailsContainer__zbTIq {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
}
.SuccessPage_details__Oe5eL {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.SuccessPage_detailsTitle__UhTTY {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #808080;
}

.SuccessPage_detailsSubtitle__3oLW- {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #333333;

}

.SuccessPage_appStoreLinkContainer__lYdaH {
  background-color: #f8f8f8;
  padding: 32px;
  padding-bottom: 0px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
}
.SuccessPage_appStoreLinkInfoContainer__qo1Vs {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.SuccessPage_appStoreLinkTitle__U71qd {
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #333333;
}
.SuccessPage_becomeAPartText__jWSOU{
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #333333;
}
.SuccessPage_appStoreLinkSubtitle__D02\\+D {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #333333;
}

.SuccessPage_shareButtonContainer__Ii\\+uA {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.SuccessPage_shareIcon__5IbSk {
  width: 32px;
  height: 32px;
}

.SuccessPage_downloadText__05lxF {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #808080;
}
.SuccessPage_downloadTypeText__7KKeh {
  color: #333333;
}

.SuccessPage_arrowIcon__macco {
  width: 12px;
  height: 12px;
}

.SuccessPage_shareButton__wxRLQ {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  background-color: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 4px 8px 0px #0000000a;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  flex: 0 1 auto;
  min-width: 140px;
}

.SuccessPage_shareButton__wxRLQ:hover {
  background-color: #fcffed;
}

.SuccessPage_shareButton__wxRLQ:active {
  transform: scale(0.98);
}

.SuccessPage_shareButton__wxRLQ:active::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 0;
  height: 0;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: SuccessPage_ripple__MGdGe 0.5s ease-out;
}

@keyframes SuccessPage_ripple__MGdGe {
  to {
    width: 200px;
    height: 200px;
    opacity: 0;
  }
}

.SuccessPage_additionalInfoSubtitle__Tb-pg {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #333333;
}

.SuccessPage_referralPolicyContainer__D-nGx {
  display: flex;
  align-items: center;
  gap: 4px;
}

.SuccessPage_additionalInfoContainer__R6kH1 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 32px;
  padding-top: 48px;
  
}

.SuccessPage_additionalInfoContainerTop__xiFrG {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.SuccessPage_referralPolicyText__oTgn4 {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #333333;
}

.SuccessPage_dollarText__UE88J {
  font-weight: 600;
}

.SuccessPage_amountText__-lSSv {
  font-weight: 600;
  font-size: 20px;
}

.SuccessPage_linkText__KflIt {
  color: #3333ff;
  cursor: pointer;
}

.SuccessPage_referralLinkContainer__7PdtY {
  border-radius: 12px;
  border: 1px solid #e6e6e6;
  background-color: #ffffff;
  width: 50%;
  padding: 0px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.SuccessPage_copyIconContainer__mXTbi {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 12px 0;
  border-left: 1px solid #e6e6e6;
  padding-left: 12px;
  width: 110px;
}

.SuccessPage_copyIcon__oOcHW {
  width: 20px;
  height: 20px;
}

.SuccessPage_referralLinkTextContainer__qEoA0 {
  padding: 12px 0;
  width: 70%;
}

.SuccessPage_referralLinkText__PINFY {
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #808080;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SuccessPage_highlight__6yfOO {
  color: #cfb277;
}

.SuccessPage_referralFormTitle__Xl1XT {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 32px;
  line-height: 1.4;
  text-align: center;
}

.SuccessPage_referralDetailsContainer__OdEQG {
  display: flex;
  flex-direction: column-reverse;
  gap: 32px;
  background: #1b013c;
  padding: 64px 120px 64px 120px;
}

.SuccessPage_referralDetailsTop__7R3o1 {
  display: flex;
  gap: 128px;
  align-items: center;
  justify-content: center;
}

.SuccessPage_referralDetailsDivider__-C5Ar {
  height: 1px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(226, 198, 107, 0) 0%,
    #4f376c 50.48%,
    rgba(226, 198, 107, 0) 100%
  );
}

.SuccessPage_referralDetailsImageWeb__du-mh {
  border-radius: 20px;
}

.SuccessPage_referralDetailsImageMobile__EThZ3 {
  display: none;
}

.SuccessPage_referralWorksHeading__NG2av {
  display: none;
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -1%;
  color: #ffffff;
  text-align: center;
  margin: 0;
}

@media (max-width: 480px) {
  .SuccessPage_referralFormTitle__Xl1XT {
    display: none;
  }

  .SuccessPage_referralDetailsContainer__OdEQG {
    flex-direction: column;
    gap: 24px;
    padding: 48px 16px 16px 16px;
  }

  .SuccessPage_referralDetailsTop__7R3o1 {
    flex-direction: column-reverse;
    gap: 24px;
    align-items: stretch;
  }

  .SuccessPage_referralWorksHeading__NG2av {
    display: block;
    margin-top: 32px;
  }

  .SuccessPage_referralDetailsImageMobile__EThZ3 {
    border-radius: 20px;
    display: block;
  }

  .SuccessPage_referralDetailsImageWeb__du-mh {
    display: none;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .SuccessPage_referralDetailsContainer__OdEQG {
    padding: 64px 32px 32px 32px;
    gap: 24px;
    flex-direction: column;
  }

  .SuccessPage_referralFormTitle__Xl1XT {
    display: none;
  }

  .SuccessPage_referralDetailsTop__7R3o1 {
    flex-direction: column-reverse;
    gap: 16px;
    align-items: stretch;
  }

  .SuccessPage_referralWorksHeading__NG2av {
    display: block;
    margin-top: 32px;
  }

  .SuccessPage_referralDetailsImageWeb__du-mh {
    border-radius: 20px;
    display: block;
  }

  .SuccessPage_referralDetailsImageMobile__EThZ3 {
    display: none;
  }
}

/* Mobile & small-screen overrides (left aligned, preserve font-sizes and keep share buttons on same line) */
@media (max-width: 480px) {
  .SuccessPage_appImage__GiqVt{
    width: 232px;
    height: 232px;
    object-fit: contain;
    align-self: center;
  }
  .SuccessPage_additionalInfoSubtitle__Tb-pg {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
  }
  .SuccessPage_successHeadingContainer__GPTw8 {
    padding-top: 52px;
    gap: 12px;
    text-align: left;
  }

  .SuccessPage_successIcon__\\+4EfR {
    width: 36px;
    height: 36px;
  }

  .SuccessPage_successPaymentText__B0zqo {
    text-align: left;
    line-height: 42px;
  }

  .SuccessPage_detailsContainer__zbTIq {
    padding: 16px;
    padding-bottom: 48px;
    gap: 12px;
    align-items: center;
    justify-content: center;
  }

  .SuccessPage_details__Oe5eL {
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    text-align: center;
  }

  .SuccessPage_detailsTitle__UhTTY {
    text-align: center;
  }

  .SuccessPage_detailsSubtitle__3oLW- {
    text-align: center;
    font-size: 18px;
  }

  .SuccessPage_appStoreLinkContainer__lYdaH {
    padding: 16px;
    padding-bottom: 0px;
    gap: 12px;
    align-items: flex-start;
    justify-content: flex-start;
  }

 .SuccessPage_appStoreLinkInfoContainer__qo1Vs {
    align-items: center;
    justify-content: center;
  }

  .SuccessPage_appStoreLinkTitle__U71qd {
    text-align: center;
    font-size: 20px;
  }

  .SuccessPage_becomeAPartText__jWSOU{
    font-size: 20px;
  }

  .SuccessPage_appStoreLinkSubtitle__D02\\+D {
    text-align: center;
  }

  .SuccessPage_shareButtonContainer__Ii\\+uA {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: flex-start;
  }

  .SuccessPage_shareButton__wxRLQ {
    flex: 1 1;
    min-width: 0;
    padding: 10px 12px;
    border-radius: 12px;
    gap: 8px;
    width: 230px;
  }

  .SuccessPage_shareIcon__5IbSk {
    width: 28px;
    height: 28px;
  }

  .SuccessPage_downloadText__05lxF {
    line-height: 20px;
    font-size: 14px;
  }

  .SuccessPage_arrowIcon__macco {
    width: 12px;
    height: 12px;
    margin-left: auto;
  }

  .SuccessPage_additionalInfoContainer__R6kH1 {
    padding: 16px;
    padding-top: 32px;
    align-items: flex-start;
    gap: 16px;
  }

  .SuccessPage_additionalInfoContainerTop__xiFrG {
    align-items: flex-start;
    gap: 8px;
  }

  .SuccessPage_referralLinkContainer__7PdtY {
    width: 100%;
    border-radius: 10px;
    justify-content: space-between;
  }

  .SuccessPage_referralLinkTextContainer__qEoA0 {
    width: calc(100% - 110px);
    padding: 8px 0;
  }

  .SuccessPage_referralLinkText__PINFY {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .SuccessPage_copyIconContainer__mXTbi {
    width: 110px;
    padding-left: 10px;
    padding-right: 6px;
    border-left: 1px solid #e6e6e6;
  }

  .SuccessPage_copyIcon__oOcHW {
    width: 18px;
    height: 18px;
  }

  .SuccessPage_referralPolicyContainer__D-nGx {
    flex-direction: row;
    align-items: flex-start;
    gap: 6px;
    padding-left: 4px;
  }

  .SuccessPage_referralPolicyText__oTgn4 {
    text-align: left;
    font-size: 14px;
  }

 
}
`, "",{"version":3,"sources":["webpack://./src/SuccessPage/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,kDAA+B;AACjC;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4GAA4G;AAC5G;EACE;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;EAC7B;;CAED;IACG,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;;AAGF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.successHeadingContainer {\n  display: flex;\n  flex-direction: column;\n  padding-top: 64px;\n  gap: 16px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.appImage{\n  width: 256px;\n  height: 256px;\n  object-fit: contain;\n  align-self: center;\n}\n\n.successIcon {\n  width: 48px;\n  height: 48px;\n}\n\n.successPaymentText {\n  margin: 0;\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 42px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #333333;\n}\n\n.detailsContainer {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-bottom: 1px solid #e6e6e6;\n}\n.details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.detailsTitle {\n  margin: 0;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #808080;\n}\n\n.detailsSubtitle {\n  margin: 0;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #333333;\n\n}\n\n.appStoreLinkContainer {\n  background-color: #f8f8f8;\n  padding: 32px;\n  padding-bottom: 0px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid #e6e6e6;\n}\n.appStoreLinkInfoContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.appStoreLinkTitle {\n  margin: 0;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #333333;\n}\n.becomeAPartText{\n  margin: 0;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #333333;\n}\n.appStoreLinkSubtitle {\n  margin: 0;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0%;\n  color: #333333;\n}\n\n.shareButtonContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n}\n\n.shareIcon {\n  width: 32px;\n  height: 32px;\n}\n\n.downloadText {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #808080;\n}\n.downloadTypeText {\n  color: #333333;\n}\n\n.arrowIcon {\n  width: 12px;\n  height: 12px;\n}\n\n.shareButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  background-color: #ffffff;\n  border: 1px solid #e6e6e6;\n  box-shadow: 0px 4px 8px 0px #0000000a;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  position: relative;\n  overflow: hidden;\n  flex: 0 1 auto;\n  min-width: 140px;\n}\n\n.shareButton:hover {\n  background-color: #fcffed;\n}\n\n.shareButton:active {\n  transform: scale(0.98);\n}\n\n.shareButton:active::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 0;\n  height: 0;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  animation: ripple 0.5s ease-out;\n}\n\n@keyframes ripple {\n  to {\n    width: 200px;\n    height: 200px;\n    opacity: 0;\n  }\n}\n\n.additionalInfoSubtitle {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #333333;\n}\n\n.referralPolicyContainer {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.additionalInfoContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 32px;\n  padding-top: 48px;\n  \n}\n\n.additionalInfoContainerTop {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.referralPolicyText {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #333333;\n}\n\n.dollarText {\n  font-weight: 600;\n}\n\n.amountText {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.linkText {\n  color: #3333ff;\n  cursor: pointer;\n}\n\n.referralLinkContainer {\n  border-radius: 12px;\n  border: 1px solid #e6e6e6;\n  background-color: #ffffff;\n  width: 50%;\n  padding: 0px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.copyIconContainer {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  padding: 12px 0;\n  border-left: 1px solid #e6e6e6;\n  padding-left: 12px;\n  width: 110px;\n}\n\n.copyIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.referralLinkTextContainer {\n  padding: 12px 0;\n  width: 70%;\n}\n\n.referralLinkText {\n  margin: 0;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #808080;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.highlight {\n  color: #cfb277;\n}\n\n.referralFormTitle {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 32px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.referralDetailsContainer {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 32px;\n  background: #1b013c;\n  padding: 64px 120px 64px 120px;\n}\n\n.referralDetailsTop {\n  display: flex;\n  gap: 128px;\n  align-items: center;\n  justify-content: center;\n}\n\n.referralDetailsDivider {\n  height: 1px;\n  width: 100%;\n  background: linear-gradient(\n    90deg,\n    rgba(226, 198, 107, 0) 0%,\n    #4f376c 50.48%,\n    rgba(226, 198, 107, 0) 100%\n  );\n}\n\n.referralDetailsImageWeb {\n  border-radius: 20px;\n}\n\n.referralDetailsImageMobile {\n  display: none;\n}\n\n.referralWorksHeading {\n  display: none;\n  font-family: Inter;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -1%;\n  color: #ffffff;\n  text-align: center;\n  margin: 0;\n}\n\n@media (max-width: 480px) {\n  .referralFormTitle {\n    display: none;\n  }\n\n  .referralDetailsContainer {\n    flex-direction: column;\n    gap: 24px;\n    padding: 48px 16px 16px 16px;\n  }\n\n  .referralDetailsTop {\n    flex-direction: column-reverse;\n    gap: 24px;\n    align-items: stretch;\n  }\n\n  .referralWorksHeading {\n    display: block;\n    margin-top: 32px;\n  }\n\n  .referralDetailsImageMobile {\n    border-radius: 20px;\n    display: block;\n  }\n\n  .referralDetailsImageWeb {\n    display: none;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .referralDetailsContainer {\n    padding: 64px 32px 32px 32px;\n    gap: 24px;\n    flex-direction: column;\n  }\n\n  .referralFormTitle {\n    display: none;\n  }\n\n  .referralDetailsTop {\n    flex-direction: column-reverse;\n    gap: 16px;\n    align-items: stretch;\n  }\n\n  .referralWorksHeading {\n    display: block;\n    margin-top: 32px;\n  }\n\n  .referralDetailsImageWeb {\n    border-radius: 20px;\n    display: block;\n  }\n\n  .referralDetailsImageMobile {\n    display: none;\n  }\n}\n\n/* Mobile & small-screen overrides (left aligned, preserve font-sizes and keep share buttons on same line) */\n@media (max-width: 480px) {\n  .appImage{\n    width: 232px;\n    height: 232px;\n    object-fit: contain;\n    align-self: center;\n  }\n  .additionalInfoSubtitle {\n    text-align: left;\n    font-weight: 500;\n    font-size: 14px;\n  }\n  .successHeadingContainer {\n    padding-top: 52px;\n    gap: 12px;\n    text-align: left;\n  }\n\n  .successIcon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .successPaymentText {\n    text-align: left;\n    line-height: 42px;\n  }\n\n  .detailsContainer {\n    padding: 16px;\n    padding-bottom: 48px;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .details {\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .detailsTitle {\n    text-align: center;\n  }\n\n  .detailsSubtitle {\n    text-align: center;\n    font-size: 18px;\n  }\n\n  .appStoreLinkContainer {\n    padding: 16px;\n    padding-bottom: 0px;\n    gap: 12px;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n .appStoreLinkInfoContainer {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .appStoreLinkTitle {\n    text-align: center;\n    font-size: 20px;\n  }\n\n  .becomeAPartText{\n    font-size: 20px;\n  }\n\n  .appStoreLinkSubtitle {\n    text-align: center;\n  }\n\n  .shareButtonContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: nowrap;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .shareButton {\n    flex: 1 1 0;\n    min-width: 0;\n    padding: 10px 12px;\n    border-radius: 12px;\n    gap: 8px;\n    width: 230px;\n  }\n\n  .shareIcon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .downloadText {\n    line-height: 20px;\n    font-size: 14px;\n  }\n\n  .arrowIcon {\n    width: 12px;\n    height: 12px;\n    margin-left: auto;\n  }\n\n  .additionalInfoContainer {\n    padding: 16px;\n    padding-top: 32px;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .additionalInfoContainerTop {\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .referralLinkContainer {\n    width: 100%;\n    border-radius: 10px;\n    justify-content: space-between;\n  }\n\n  .referralLinkTextContainer {\n    width: calc(100% - 110px);\n    padding: 8px 0;\n  }\n\n  .referralLinkText {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .copyIconContainer {\n    width: 110px;\n    padding-left: 10px;\n    padding-right: 6px;\n    border-left: 1px solid #e6e6e6;\n  }\n\n  .copyIcon {\n    width: 18px;\n    height: 18px;\n  }\n\n  .referralPolicyContainer {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 6px;\n    padding-left: 4px;\n  }\n\n  .referralPolicyText {\n    text-align: left;\n    font-size: 14px;\n  }\n\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SuccessPage_container__05SLA`,
	"successHeadingContainer": `SuccessPage_successHeadingContainer__GPTw8`,
	"appImage": `SuccessPage_appImage__GiqVt`,
	"successIcon": `SuccessPage_successIcon__+4EfR`,
	"successPaymentText": `SuccessPage_successPaymentText__B0zqo`,
	"detailsContainer": `SuccessPage_detailsContainer__zbTIq`,
	"details": `SuccessPage_details__Oe5eL`,
	"detailsTitle": `SuccessPage_detailsTitle__UhTTY`,
	"detailsSubtitle": `SuccessPage_detailsSubtitle__3oLW-`,
	"appStoreLinkContainer": `SuccessPage_appStoreLinkContainer__lYdaH`,
	"appStoreLinkInfoContainer": `SuccessPage_appStoreLinkInfoContainer__qo1Vs`,
	"appStoreLinkTitle": `SuccessPage_appStoreLinkTitle__U71qd`,
	"becomeAPartText": `SuccessPage_becomeAPartText__jWSOU`,
	"appStoreLinkSubtitle": `SuccessPage_appStoreLinkSubtitle__D02+D`,
	"shareButtonContainer": `SuccessPage_shareButtonContainer__Ii+uA`,
	"shareIcon": `SuccessPage_shareIcon__5IbSk`,
	"downloadText": `SuccessPage_downloadText__05lxF`,
	"downloadTypeText": `SuccessPage_downloadTypeText__7KKeh`,
	"arrowIcon": `SuccessPage_arrowIcon__macco`,
	"shareButton": `SuccessPage_shareButton__wxRLQ`,
	"ripple": `SuccessPage_ripple__MGdGe`,
	"additionalInfoSubtitle": `SuccessPage_additionalInfoSubtitle__Tb-pg`,
	"referralPolicyContainer": `SuccessPage_referralPolicyContainer__D-nGx`,
	"additionalInfoContainer": `SuccessPage_additionalInfoContainer__R6kH1`,
	"additionalInfoContainerTop": `SuccessPage_additionalInfoContainerTop__xiFrG`,
	"referralPolicyText": `SuccessPage_referralPolicyText__oTgn4`,
	"dollarText": `SuccessPage_dollarText__UE88J`,
	"amountText": `SuccessPage_amountText__-lSSv`,
	"linkText": `SuccessPage_linkText__KflIt`,
	"referralLinkContainer": `SuccessPage_referralLinkContainer__7PdtY`,
	"copyIconContainer": `SuccessPage_copyIconContainer__mXTbi`,
	"copyIcon": `SuccessPage_copyIcon__oOcHW`,
	"referralLinkTextContainer": `SuccessPage_referralLinkTextContainer__qEoA0`,
	"referralLinkText": `SuccessPage_referralLinkText__PINFY`,
	"highlight": `SuccessPage_highlight__6yfOO`,
	"referralFormTitle": `SuccessPage_referralFormTitle__Xl1XT`,
	"referralDetailsContainer": `SuccessPage_referralDetailsContainer__OdEQG`,
	"referralDetailsTop": `SuccessPage_referralDetailsTop__7R3o1`,
	"referralDetailsDivider": `SuccessPage_referralDetailsDivider__-C5Ar`,
	"referralDetailsImageWeb": `SuccessPage_referralDetailsImageWeb__du-mh`,
	"referralDetailsImageMobile": `SuccessPage_referralDetailsImageMobile__EThZ3`,
	"referralWorksHeading": `SuccessPage_referralWorksHeading__NG2av`
};
export default ___CSS_LOADER_EXPORT___;
